<script>
    import Navbar from "./comps/navbar.svelte";
    import Slidbar from "./comps/sidebar.svelte";
    import Dashboard from "./comps/dashboard.svelte";
    import Rolelist from "./comps/rolelist.svelte";
    import Userlist from "./comps/userlist.svelte";
    import Loglist from "./comps/loglist.svelte";
    import Person from "./comps/person.svelte";
    import DeviceMonitor from "./comps/devicemonitor.svelte";
    import VersionQuery from "./comps/versionquery.svelte";
    import HistoryData from "./comps/historydata.svelte";
	import Constructing from "./comps/constructing.svelte";
    import FixTool from "./comps/fixtool.svelte";
    import Abnormal from "./comps/abnormal.svelte";
    import ClearDeviceData from "./comps/cleardevicedata.svelte";
    import RemoteControl from "./comps/remotecontrol.svelte";
    
    export let name;
    let cur_nickname = CommonLib.getAppStorage("iotdc_cur_nickname");
    if (!cur_nickname || cur_nickname == "") {
        window.location = "/login.html";
    }
    let cookie_nickname = "";
    jQuery.ajax({
        type: "get",
        url: "/dbapi/checkcookie",
        async:false,
        success: function (response) {
            if (response.code == 200) {
                cookie_nickname = response.result;
            }
        },
    });
    console.log(cookie_nickname);
    if (cur_nickname != cookie_nickname) {
        window.location = "/login.html";
    }
    console.log("cookie check pass");
    let cur_cnname = CommonLib.getAppStorage("iotdc_cur_cnname");
	let navchoice = "1-1"; // 默认首页
    const myrouter = [
        "0-1",
        "0-2",
        "0-3",
        "1-1",
        "1-2",
        "2-1",
        "2-2",
        "2-3",
        "3-1",
        "3-2",
        "3-3",
        "3-4",
        "3-5"
	];
    let sParam = window.location.search;
    let retSplit = sParam.split("=");
    if (retSplit.length > 1) {
        // 带参数
        if (retSplit[0] == "?p") {
            if (myrouter.includes(retSplit[1])) {
                navchoice = retSplit[1];
            }
        }
    }
</script>

<main>
	<div class="wrapper">
		<!-- Navbar -->
		<Navbar />
		<!-- Main Sidebar -->
		<Slidbar {name} curnickname={cur_nickname} bind:choice={navchoice} />
		<!-- Content-wrapper -->
		{#if navchoice == "1-1"}
			<Dashboard />
		{:else if navchoice == "1-2"}
			<Person />
		{:else if navchoice == "2-1"}
			<DeviceMonitor />
		{:else if navchoice == "2-2"}
			<HistoryData />
		{:else if navchoice == "2-3"}
			<Abnormal/>
        {:else if navchoice == "3-1"}
			<VersionQuery />
		{:else if navchoice == "3-2"}
			<RemoteControl />
		{:else if navchoice == "3-3"}
			<Constructing />
        {:else if navchoice == "3-4"}
			<FixTool />
        {:else if navchoice == "3-5"}
			<ClearDeviceData />
		{:else if navchoice == "0-1"}
			<Rolelist />
		{:else if navchoice == "0-2"}
			<Userlist />
		{:else if navchoice == "0-3"}
			<Loglist />
		{:else}
			<Constructing />
		{/if}
	</div>
</main>

<style>
</style>
